module.exports = __webpack_public_path__ + "img/icons B_1.42d45c4e.png";